import { render, staticRenderFns } from "./PolicyBoxes.vue?vue&type=template&id=57ec9df4&"
import script from "./PolicyBoxes.vue?vue&type=script&lang=js&"
export * from "./PolicyBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports